import React, {useState,useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BasicLayout from 'components/atoms/Modal/Basic.Layout';
import { isACtiveFeedbackModal } from 'modules/actions/statusMenu';
import { chatList } from 'modules/actions/chat';
import { weBrowser } from 'lib';

const Feedback = () => {
  const dispatch = useDispatch();
  const StarName = ['매우불편', '불편', '보통', '만족', '매우만족'];
  const [getStar, setStar] = useState(5);
  const feed_text = useRef(false);
  const feed = useSelector(state => state.isActive.feedbackModal);
  /*
  * 별점평가 보내기 클릭 이벤트
  */
  const sendFeedBack = () =>{
    const paramSet = {
      inType: 'quality',
      quality: {
        value: getStar,
        comment: feed_text.current.value
      },
      message_id:feed.id
      
    };
    dispatch(chatList(paramSet));
    dispatch(isACtiveFeedbackModal());
  }

  /**
   * 별점평가 모달창의 별모양 클릭 이벤트
   * @param {*} e
   */
  const clickstar = e => {
    const selectedStar = parseInt(e.target.attributes.name.value,10);
    setStar(selectedStar);
    fillStar(selectedStar)
  }

  /**
   * 선택된 별의 개수만큼 모달창의 별 색칠하기
   * @param {*} selectedStar
   */
     const fillStar = selectedStar => {
      const starList = document.querySelector('.satis_star_box').childNodes;
      console.log(selectedStar)
      for (let i = 0; i < starList.length; i ++) {
        if (i < selectedStar) {
          starList[i].setAttribute('class', 'satis_star sel');
        } else {
          starList[i].setAttribute('class', 'satis_star');
        }
      }
    };

  const constentSet = () => {
    return (
      <>
        <div className="feed_title">
          더 나은 서비스를 위해 <br />
          만족도 및 의견을 듣고 있습니다. <br />
          의견 입력 후 보내기 버튼을 클릭해주세요.
        </div>
        <div className="satis_star_box">
          <em className="satis_star sel" name="1" onClick={clickstar}/>
          <em className="satis_star sel" name="2" onClick={clickstar}/>
          <em className="satis_star sel" name="3" onClick={clickstar}/>
          <em className="satis_star sel" name="4" onClick={clickstar}/>
          <em className="satis_star sel" name="5" onClick={clickstar}/>
        </div>
        <div className="satis_subtitle">[{StarName[getStar - 1]}]</div>
        <div className="feed_input">
          <textarea
            // onChange={setFeedText}
            ref={feed_text}
            maxLength={500}
            className="feed_input_textarea"
            placeholder="답변에 대한 의견을 자유롭게 남겨주세요&#13;&#10;(500자 제한)"
          />
        </div>
        <div className="feed_send_btn" onClick={sendFeedBack}>만족도 및 의견 보내기</div>
      </>
    );
  };

  return (
    <BasicLayout
      label="서비스 만족도 평가"
      value="서비스 만족도 평가"
      labelIcon="ri-thumb-up-line"
      viewStatus=""
      styleDef={{  height: weBrowser() ==='ie'? '418px':'auto',zIndex:'15' }}
      onClickEvt={() => dispatch(isACtiveFeedbackModal())}
      error={null}
      contentSet={constentSet}
    />
  );
};

export default Feedback;
